import DOMPurify from 'dompurify';

const ALLOWED_URL_PROTOCOLS = ['http:', 'https:', 'mailto:', 'tel:'];

export const sanitizePlainText = value =>
  DOMPurify.sanitize(String(value ?? ''), { ALLOWED_TAGS: [], ALLOWED_ATTR: [] });

export const sanitizeHtml = value =>
  DOMPurify.sanitize(String(value ?? ''), { USE_PROFILES: { html: true } });

const rejectedPathname = pathname => {
  const normalized = String(pathname || '').replace(/\/+$/, '') || '/';
  return normalized === '/null' || normalized === '/undefined';
};

export const sanitizeUrl = value => {
  const sanitized = sanitizePlainText(value).trim();

  if (!sanitized) {
    return '';
  }

  if (sanitized.startsWith('/')) {
    return rejectedPathname(sanitized) ? '' : sanitized;
  }

  try {
    const parsed = new URL(sanitized, window.location.origin);

    if (!ALLOWED_URL_PROTOCOLS.includes(parsed.protocol)) {
      return '';
    }

    if (rejectedPathname(parsed.pathname)) {
      return '';
    }

    return parsed.href;
  } catch (error) {
    return '';
  }
};
